<template>
  <v-navigation-drawer
    v-model="drawer"
    width="400"
    app
    temporary
    right
    class="wost-drawer"
  >
    <div class="navigation-head">
      <span>{{ titleForm }}</span>
    </div>

    <div class="pl-3 pt-3 pr-3" style="height: 80vh;">
      <template>
        <v-row>
          <v-col cols="12">
            <v-text-field
              ref="codigo"
              v-model="materialForm.codigo"
              label="Codigo"
              outlined
              :rules="[
                () =>
                  !!materialForm.codigo || 'Es necesario ingresar un Codigo',
              ]"
              hide-details="auto"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-text-field
              ref="description"
              v-model="materialForm.description"
              label="Nombre"
              outlined
              :rules="[
                () =>
                  !!materialForm.description ||
                  'Es necesario ingresar un nombre',
              ]"
              hide-details="auto"
              required
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <!-- <v-col cols="12">
                        <v-textarea
                            v-model="materialForm.description"
                            outlined
                            label="Descripción"
                            >
                        </v-textarea>
                    </v-col> -->
          <v-col cols="12">
            <v-autocomplete
              ref="tipo_material"
              :value="materialForm.tipo_material"
              v-model="materialForm.tipo_material"
              :items="tipoProductos"
              label="Tipo Producto"
              outlined
              :item-text="customText"
              item-value="id"
              disabled="disabled"
              :rules="[
                () =>
                  !!materialForm.tipo_material ||
                  'Es necesario seleccionar Tipo Producto',
              ]"
              hide-details="auto"
              required
            ></v-autocomplete>
          </v-col>
          <v-col cols="12">
            <v-autocomplete
              ref="categoria"
              :value="materialForm.categoria"
              v-model="materialForm.categoria"
              :items="categorias"
              label="Categoria"
              outlined
              :item-text="customText"
              item-value="id"
              :rules="[
                () =>
                  !!materialForm.categoria ||
                  'Es necesario seleccionar Categoria',
              ]"
              hide-details="auto"
              required
            ></v-autocomplete>
          </v-col>
          <v-col cols="12">
            <v-autocomplete
              ref="marca"
              :value="materialForm.marca"
              v-model="materialForm.marca"
              :items="marcas"
              label="Marca"
              outlined
              :item-text="customText"
              item-value="id"
              :rules="[
                () => !!materialForm.marca || 'Es necesario seleccionar Marca',
              ]"
              hide-details="auto"
              required
            ></v-autocomplete>
          </v-col>
          <v-col cols="12">
            <v-autocomplete
              ref="unidadMedida"
              :value="materialForm.unidadMedida"
              v-model="materialForm.unidadMedida"
              :items="unidadMedidas"
              label="Unidad Medidad"
              outlined
              :item-text="customText"
              item-value="id"
              :rules="[
                () =>
                  !!materialForm.unidadMedida ||
                  'Es necesario seleccionar Unidad Medida',
              ]"
              hide-details="auto"
              required
            ></v-autocomplete>
          </v-col>
          <v-col cols="12">
            <v-text-field
              ref="precioCompra"
              v-model="materialForm.precioCompra"
              label="Precio Compra"
              outlined
              :rules="[
                () =>
                  !!materialForm.precioCompra ||
                  'Es necesario ingresar un Precio Compra',
              ]"
              hide-details="auto"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-text-field
              ref="stockMinimo"
              v-model="materialForm.stockMinimo"
              label="Stock Minimo"
              outlined
              :rules="[
                () =>
                  !!materialForm.stockMinimo ||
                  'Es necesario ingresar un Stok Minimo',
              ]"
              hide-details="auto"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-text-field
              ref="cantPruebas"
              v-model="materialForm.cantPruebas"
              label="Cantidad Pruebas"
              outlined
              :rules="[
                () =>
                  !!materialForm.cantPruebas ||
                  'Es necesario ingresar una Cantidad de Pruebas',
              ]"
              hide-details="auto"
              required
            ></v-text-field>
          </v-col>
        </v-row>
      </template>
    </div>

    <div class="mt-3 pl-3 pt-3 pr-3">
      <template>
        <v-row>
          <v-col cols="6">
            <v-btn block height="40" dark color="red" @click="handleCancel">
              <v-icon class="mr-1" size="16">far fa-times-circle</v-icon>
              Cancelar
            </v-btn>
          </v-col>
          <v-col cols="6">
            <v-btn
              v-if="action == 'create'"
              dark
              color="success"
              block
              height="40"
              @click="handleStore"
            >
              <v-icon class="mr-1" size="16">far fa-save</v-icon>
              Guardar
            </v-btn>
            <v-btn
              v-if="action == 'update'"
              dark
              color="success"
              block
              height="40"
              @click="handleUpdate"
            >
              <v-icon class="mr-1" size="16">far fa-save</v-icon>
              Actualizar
            </v-btn>
          </v-col>
        </v-row>
      </template>
    </div>
  </v-navigation-drawer>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "CreateUpdate",
  data() {
    return {
      drawer: false,
      titleForm: null,
      action: null,
      materialForm: {
        id: null,
        codigo: null,
        description: null,
        tipo_material: null,
        categoria: null,
        marca: null,
        unidadMedida: null,
        precioCompra: null,
        stockMinimo: null,
        stock: null,
        cant_pruebas: null,
        cantPruebas: null,
      },
    };
  },
  computed: {
    ...mapState("reactive", [
      "categorias",
      "marcas",
      "unidadMedidas",
      "tipoProductos",
    ]),
  },
  methods: {
    ...mapActions("reactive", [
      "store",
      "update",
      "getCategoria",
      "getMarca",
      "getUnidadMedida",
    ]),
    customText(item) {
      let text = item.name;
      return text;
    },
    async showForm(title, action, reactive = null) {
      await this.clearData();
      this.titleForm = title;
      this.action = action;
      this.materialForm.tipo_material = "REACTIVO";
      reactive && this.setMaterial(reactive);
      this.getCategoria();
      this.getMarca();
      this.getUnidadMedida();
      this.drawer = !this.drawer;
      // console.log(title, action, reactive)
    },
    clearData() {
      (this.id = null),
        (this.codigo = null),
        (this.name = null),
        (this.description = null),
        (this.tipo_material = null),
        (this.categoria = null),
        (this.marca = null),
        (this.unidadMedida = null),
        (this.precioCompra = null),
        (this.stockMinimo = null),
        (this.stock = null),
        this.clearErrors();
    },
    setMaterial(reactive) {
      this.materialForm.id = reactive.id;
      this.materialForm.codigo = reactive.code;
      this.materialForm.description = reactive.description;
      this.materialForm.tipo_material = reactive.type_lab;
      this.materialForm.categoria = this.categorias.find(
        (response) => response.name === reactive.category_name
      );
      this.materialForm.marca = this.marcas.find(
        (response) => response.name === reactive.brands_name
      );
      this.materialForm.unidadMedida = this.unidadMedidas.find(
        (response) => response.name === reactive.unit_name
      );
      this.materialForm.precioCompra = reactive.cost;
      this.materialForm.stockMinimo = reactive.minimum_stock;
      this.materialForm.stock = reactive.stock;
      this.materialForm.cant_pruebas = reactive.cant_pruebas;
      this.materialForm.cantPruebas = reactive.cantPruebas;
      // console.log(reactive)
      // this.marcas.map((response) => console.log(response.name))
      // this.unidadMedidas.map((response) => console.log(response.name))
      // console.log(this.marcas.filter((response) => response === reactive.brands_name))
      // console.log(this.unidadMedidas.filter((response) => response === reactive.unit_name))
      // console.log(this.materialForm.categoria, this.materialForm.marca, this.materialForm.unidadMedida)
    },
    closeForm() {
      this.clearData();
      this.drawer = false;
    },
    handleCancel() {
      this.closeForm();
    },
    async handleStore() {
      if (!this.existErrors()) {
        const {
          id,
          codigo,
          description,
          tipo_material,
          categoria,
          cantPruebas,
        } = this.materialForm;
        const {
          marca,
          unidadMedida,
          precioCompra,
          stockMinimo,
          stock,
          cant_pruebas,
        } = this.materialForm;
        await this.store({
          id,
          codigo,
          description,
          tipo_material,
          categoria,
          marca,
          unidadMedida,
          precioCompra,
          stockMinimo,
          stock,
          cantPruebas,
        });
        this.closeForm();
      }
    },
    async handleUpdate() {
      if (!this.existErrors()) {
        const {
          id,
          codigo,
          description,
          tipo_material,
          categoria,
          cantPruebas,
        } = this.materialForm;
        const {
          marca,
          unidadMedida,
          precioCompra,
          stockMinimo,
          stock,
          cant_pruebas,
        } = this.materialForm;
        await this.update({
          id,
          codigo,
          description,
          tipo_material,
          categoria,
          marca,
          unidadMedida,
          precioCompra,
          stockMinimo,
          stock,
          cantPruebas,
        });
        // this.closeForm()
      }
    },
    existErrors() {
      let hasErrors = false;

      Object.keys(this.materialForm).forEach((f) => {
        if (this.$refs[f]) {
          if (!this.materialForm[f]) hasErrors = true;
          this.$refs[f].validate(true);
        }
      });

      return hasErrors;
    },
    clearErrors() {
      Object.keys(this.materialForm).forEach((f) => {
        if (this.$refs[f]) this.$refs[f].reset();
      });
    },
  },
};
</script>

<style scoped></style>
